import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MinhaAgendaComponent} from "./pages/minha-agenda/minha-agenda.component";

const routes: Routes = [
  { path: "", component: MinhaAgendaComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgendaRoutingModule { }
